import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  BottomNavigation,
  BottomNavigationAction,
  Paper,
} from '@mui/material';
import {
  Home,
  Search,
  Archive,
  Person,
  LocalBar,
} from '@mui/icons-material';
import { ROUTES } from '../../../core/config/constants';

export const AppBottomNavigation: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const getCurrentValue = () => {
    const path = location.pathname;
    if (path === ROUTES.BOTTLES || path === '/') return 0;
    if (path === ROUTES.SEARCH) return 1;
    if (path === ROUTES.ARCHIVED) return 2;
    if (path === ROUTES.PROFILE) return 3;
    return 0;
  };

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    switch (newValue) {
      case 0:
        navigate(ROUTES.BOTTLES);
        break;
      case 1:
        navigate(ROUTES.SEARCH);
        break;
      case 2:
        navigate(ROUTES.ARCHIVED);
        break;
      case 3:
        navigate(ROUTES.PROFILE);
        break;
    }
  };

  return (
    <Paper
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 1000,
        backgroundColor: 'background.default', // Utilise le noir de fond au lieu du gris Paper
        borderRadius: '20px 20px 0 0', // Même arrondi que le BottomNavigation
      }}
      elevation={8}
    >
      <BottomNavigation
        value={getCurrentValue()}
        onChange={handleChange}
        showLabels
        sx={{
          backgroundColor: 'background.default',
          borderRadius: '20px 20px 0 0',
          '& .MuiBottomNavigationAction-root': {
            color: '#CCCCCC',
            borderRadius: '12px',
            margin: '4px',
            '&.Mui-selected': {
              color: '#FFFFFF',
              backgroundColor: '#8B2F54',
              border: '2px solid #8B2F54',
            },
          },
        }}
      >
        <BottomNavigationAction
          label="Ma Cave"
          icon={<LocalBar />}
        />
        <BottomNavigationAction
          label="Recherche"
          icon={<Search />}
        />
        <BottomNavigationAction
          label="Archivées"
          icon={<Archive />}
        />
        <BottomNavigationAction
          label="Profil"
          icon={<Person />}
        />
      </BottomNavigation>
    </Paper>
  );
};